import { z } from 'zod';
import { BaseResponseSchema, uuidSchema, } from './primitives.js';
import { DeviceInventoryStatusSchema, OpsDeviceCategorySchema, } from './device-inventory.schemas.js';
export const MfgNonIotDeviceRowSchema = z.object({
    // Canonical Cnapse Serial Number
    serialNumber: z.string().min(1).max(64).optional(),
    vendorSerialNumber: z.string().min(1).max(128).optional(),
    macAddress: z.string().min(1).max(128),
    manufacturerName: z.string().min(1).max(255).optional(),
    deviceCategory: OpsDeviceCategorySchema.refine((c) => !['efem-gateway', 'location-gateway', 'multi-gateway'].includes(c), { message: 'Use /api/mfg/devices/register-batch-iot for IoT devices' }),
    model: z.string().min(1).max(128),
    mfgBatch: z.string().min(1).max(64),
    mfgDate: z.string().refine((s) => /^\d{4}-\d{2}-\d{2}$/.test(s) || /^(1[0-2]|0?[1-9])\/(3[01]|[12][0-9]|0?[1-9])\/\d{4}$/.test(s), { message: 'mfgDate must be YYYY-MM-DD or M/D/YYYY' }),
    vendorDeviceId: z.string().max(128).optional(),
});
export const AllocateDeviceRequestSchema = z.object({
    tenantId: uuidSchema,
    orderId: z.string().min(1).max(128),
    notes: z.string().max(500).optional(),
});
export const AllocateDeviceResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        serialNumber: z.string(),
        inventoryStatus: DeviceInventoryStatusSchema,
        claimCode: z.string().optional(),
        claimCodeExpiresAt: z.string().optional(),
        allocatedAt: z.string(),
    }),
});
export const MarkShippedRequestSchema = z.object({ notes: z.string().max(500).optional() });
export const ActivateDeviceRequestSchema = z.object({ notes: z.string().max(500).optional() });
export const ReturnDeviceRequestSchema = z.object({
    reason: z.string().min(1).max(500),
    notes: z.string().max(500).optional(),
});
export const RetireDeviceRequestSchema = z.object({
    reason: z.string().min(1).max(500),
    notes: z.string().max(500).optional(),
});
export const InventoryStateTransitionResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        serialNumber: z.string(),
        inventoryStatus: DeviceInventoryStatusSchema,
    }),
});
export const BatchClaimRequestSchema = z.object({
    claimCodes: z.array(z.string().regex(/^[A-Z0-9]{4}-[A-Z0-9]{4}$/)).min(1).max(100),
});
export const BatchClaimResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        succeeded: z.array(z.object({ serialNumber: z.string(), claimCode: z.string() })),
        failed: z.array(z.object({ claimCode: z.string(), reason: z.string() })),
    }),
});
export const RegenerateClaimCodeRequestSchema = z.object({ notes: z.string().max(500).optional() });
export const RegenerateClaimCodeResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        serialNumber: z.string(),
        claimCode: z.string(),
        claimCodeExpiresAt: z.string(),
    }),
});
//# sourceMappingURL=ops-inventory-lifecycle.schemas.js.map